import React, { useState, useEffect, useMemo } from "react";
import FormCity from "./FormCity";
import { fetchCities, addCity, updateCity, deleteCity } from "../../../actions/regionAction/cityAction";
import { fetchProvinces } from "../../../actions/regionAction/provinceAction";
import { connect } from "react-redux";
import { AlertConfirmModal } from "../../../components/Modals/AlertConfirmModal";
import { sortHelper } from "../../../utils/helpers/sortHelper";
import { useSearchParams } from "react-router-dom";
import debounce from "lodash/debounce";

const CityPage = (props) => {
  const {
    dataCities,
    cities,
    addCity,
    updateCity,
    deleteCity,
    isLoading,
    fetchCities,
    isLoadingProvince,
    provinces,
    fetchProvinces,
  } = props;

  const [perPage, setPerPage] = useState(100);
  const [currentPage, setCurrentPage] = useState(1);

  const handlePerPageChange = (value) => {
    setPerPage(value);
    setCurrentPage(1);
  };
  const initialState = {
    id: "",
    name: "",
    province_id: "",
  };

  const [isShowModal, setIsShowModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const searchFromUrl = searchParams.get("search") || "";

  const [filterText, setFilterText] = useState(searchFromUrl);

  const [formState, setFormState] = useState(initialState);
  const { sortConfig, handleSort, getSortedData } = sortHelper.useSort();

  const closeModal = () => {
    setFormState(initialState);
    setIsShowModal(false);
    setIsEdit(false);
  };
  const handleDelete = (id, reason) => {
    deleteCity(id, reason);
  };
  const handleAdd = async () => {
    const success = await addCity(formState);
    if (success) closeModal();
    return success;
  };
  const handleUpdate = async () => {
    const success = await updateCity(formState?.id, formState);
    if (success) closeModal();
    return success;
  };
  const handleSearchChange = (e) => {
    const value = e.target.value;
    setFilterText(value);

    if (value) {
      setSearchParams({ search: value });
    } else {
      setSearchParams({});
    }
  };

  useEffect(() => {
    setFilterText(searchFromUrl);
  }, [searchFromUrl]);

  const debouncedFetch = useMemo(
    () =>
      debounce((page, limit, search) => {
        fetchCities(limit, page, search);
      }, 500),
    [fetchCities],
  );
  useEffect(() => {
    debouncedFetch(currentPage, perPage, searchFromUrl);

    return () => {
      debouncedFetch.cancel();
    };
  }, [currentPage, perPage, searchFromUrl, debouncedFetch]);
  useEffect(() => {
    setCurrentPage(1);
  }, [searchFromUrl]);

  return (
    <div className="page-wrapper">
      <div className="page-header d-print-none">
        <div className="container-xl">
          <div className="row g-2 align-items-center">
            <div className="col">
              <h1 className="page-title fs-1 text-capitalize">Data Kabupaten/Kota</h1>
              <div className="page-pretitle">master kabupaten/kota</div>
            </div>
            <div className="col-auto ms-auto d-print-none">
              <div className="btn-list">
                <button
                  type="button"
                  className="btn btn-primary btn-5 d-none d-sm-inline-block"
                  data-bs-toggle="modal"
                  data-bs-target="#modal-form"
                  onClick={() => {
                    setFormState(initialState);
                    setIsEdit(false);
                  }}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="icon icon-2">
                    <path d="M12 5l0 14" />
                    <path d="M5 12l14 0" />
                  </svg>
                  Tambah Kabupaten/Kota
                </button>
                <button
                  type="button"
                  className="btn btn-primary btn-6 d-sm-none btn-icon"
                  data-bs-toggle="modal"
                  data-bs-target="#modal-form">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="icon icon-2">
                    <path d="M12 5l0 14" />
                    <path d="M5 12l14 0" />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="page-body">
        <div className="container-xl">
          <div className="row row-deck row-cards">
            <div className="col-12">
              <div className="card">
                <div className="card-table">
                  <div className="card-header ">
                    <div className="row w-full">
                      <div className="col-md-9 col-12">
                        <h3 className="card-title mb-0">Kabupaten/Kota</h3>
                        <p className="text-secondary m-0">Master Wilayah Kabupaten/Kota </p>
                      </div>
                      <div className="col-md-3 col-12 my-md-0 my-2">
                        <div className="input-group input-group-flat w-auto">
                          <span className="input-group-text">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="icon icon-1">
                              <path d="M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0" />
                              <path d="M21 21l-6 -6" />
                            </svg>
                          </span>
                          <input
                            id="advanced-table-search"
                            type="text"
                            className="form-control"
                            autoComplete="off"
                            onChange={handleSearchChange}
                            placeholder="Cari..."
                            value={filterText}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div id="advanced-table">
                    <div className="table-responsive">
                      <table className="table table-vcenter table-selectable">
                        <thead className="table-header">
                          <tr>
                            <th className="sort-name py-3 w-1">No.</th>
                            <sortHelper.SortableHeader
                              label="Kode"
                              sortKey="id"
                              sortConfig={sortConfig}
                              onSort={handleSort}
                            />

                            <sortHelper.SortableHeader
                              label="Kabupaten/Kota"
                              sortKey="name"
                              sortConfig={sortConfig}
                              onSort={handleSort}
                            />
                            <th className="sort-status fw-bold">Status</th>
                            <th
                              className="text-start"
                              style={{
                                width: "25%",
                              }}></th>
                          </tr>
                        </thead>

                        <tbody className="table-tbody">
                          {isLoading
                            ? [...Array(cities?.length || 10)]?.map((_, index) => (
                                <tr
                                  key={`loading-${index}`}
                                  style={{
                                    cursor: "loader",
                                  }}>
                                  <td className="sort-name py-4">{(currentPage - 1) * perPage + index + 1}.</td>
                                  {[...Array(3)]?.map((_, i) => (
                                    <td key={i}>
                                      <div className="placeholder placeholder-lg w-75"></div>
                                    </td>
                                  ))}
                                  <td className="justify-content-start text-start flex-nowrap">
                                    <div
                                      className="placeholder placeholder-lg me-2 "
                                      style={{
                                        width: "40%",
                                      }}></div>
                                    <div
                                      className="placeholder placeholder-lg "
                                      style={{
                                        width: "40%",
                                      }}></div>
                                  </td>
                                </tr>
                              ))
                            : getSortedData(cities)?.map((city, index) => (
                                <tr key={city.id}>
                                  <td className="sort-name">{(currentPage - 1) * perPage + index + 1}.</td>
                                  <td className="sort-name">
                                    <span className="badge fw-bold">{city?.id}</span>
                                  </td>
                                  <td className="sort-city text-uppercase">{city?.name}</td>
                                  <td className="sort-status">
                                    <span className="badge bg-success-lt">Active</span>
                                  </td>
                                  <td>
                                    <div className="btn-list flex-nowrap justify-content-center">
                                      <button
                                        type="button"
                                        className="btn btn-1 bg-secondary-lt"
                                        data-bs-toggle="modal"
                                        data-bs-target="#modal-form"
                                        aria-label={`Edit kabupaten atau kota ${city?.name || ""}`.trim()}
                                        onClick={() => {
                                          setIsEdit(true);
                                          setFormState({
                                            id: city?.id,
                                            name: city?.name,
                                            province_id: city?.province_id,
                                          });
                                          setIsShowModal(true);
                                        }}>
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="24"
                                          height="24"
                                          viewBox="0 0 24 24"
                                          fill="none"
                                          stroke="currentColor"
                                          strokeWidth="2"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                          className="icon icon-tabler icons-tabler-outline icon-tabler-edit">
                                          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                          <path d="M7 7h-1a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-1" />
                                          <path d="M20.385 6.585a2.1 2.1 0 0 0 -2.97 -2.97l-8.415 8.385v3h3l8.385 -8.415z" />
                                          <path d="M16 5l3 3" />
                                        </svg>{" "}
                                        Edit{" "}
                                      </button>
                                      <button
                                        type="button"
                                        className="btn btn-1 bg-danger-lt"
                                        data-bs-toggle="modal"
                                        data-bs-target="#modal-alert"
                                        aria-label={`Hapus kabupaten atau kota ${city?.name || ""}`.trim()}
                                        onClick={() => {
                                          setFormState({
                                            id: city?.id,
                                            name: city?.name,
                                          });
                                        }}>
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="24"
                                          height="24"
                                          viewBox="0 0 24 24"
                                          fill="none"
                                          stroke="currentColor"
                                          strokeWidth="2"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                          className="icon icon-tabler icons-tabler-outline icon-tabler-trash">
                                          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                          <path d="M4 7l16 0" />
                                          <path d="M10 11l0 6" />
                                          <path d="M14 11l0 6" />
                                          <path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12" />
                                          <path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3" />
                                        </svg>{" "}
                                        Hapus
                                      </button>
                                    </div>
                                  </td>
                                </tr>
                              ))}
                        </tbody>
                      </table>
                    </div>
                    <div className="card-footer d-flex align-items-center">
                      <div className="dropdown">
                        <button className="btn dropdown-toggle" data-bs-toggle="dropdown">
                          <span id="page-count" className="me-1">
                            {perPage}
                          </span>
                          <span>records</span>
                        </button>
                        <div className="dropdown-menu">
                          {[10, 20, 50, 100]?.map((value) => (
                            <button key={value} className="dropdown-item" onClick={() => handlePerPageChange(value)}>
                              {value} records
                            </button>
                          ))}
                        </div>
                      </div>
                      <div className="d-flex ">
                        <p className="ms-2 my-auto text-secondary">
                          {dataCities?.per_page} dari <span>{dataCities?.total}</span> <span>data</span>
                        </p>
                      </div>

                      <ul className="pagination m-0 ms-auto">
                        {/* PREV BUTTON */}
                        <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                          <button className="page-link" onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}>
                            <svg width="24" height="24" stroke="currentColor" fill="none" viewBox="0 0 24 24">
                              <path d="M15 6l-6 6l6 6" />
                            </svg>
                          </button>
                        </li>

                        {/* PAGE NUMBERS */}
                        {dataCities?.links?.slice(1, -1)?.map((item, index) => {
                          const pageNumber = item.url ? new URL(item.url).searchParams.get("page") : null;

                          return (
                            <li key={index} className={`page-item ${item?.active ? "active" : ""}`}>
                              <button
                                className="page-link"
                                disabled={!pageNumber}
                                onClick={() => pageNumber && setCurrentPage(Number(pageNumber))}>
                                {item.label}
                              </button>
                            </li>
                          );
                        })}

                        {/* NEXT BUTTON */}
                        <li className={`page-item ${currentPage === dataCities?.last_page ? "disabled" : ""}`}>
                          <button
                            className="page-link"
                            onClick={() => setCurrentPage(parseInt(dataCities?.current_page) + 1)}>
                            <svg width="24" height="24" stroke="currentColor" fill="none" viewBox="0 0 24 24">
                              <path d="M9 6l6 6l-6 6" />
                            </svg>
                          </button>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <FormCity
        isShowModal={isShowModal}
        isEdit={isEdit}
        closeModal={closeModal}
        formState={formState}
        setFormState={setFormState}
        fetchProvinces={fetchProvinces}
        provinces={provinces}
        isLoading={isLoadingProvince}
        handleAdd={handleAdd}
        handleUpdate={handleUpdate}
      />
      <AlertConfirmModal
        type="error"
        message={`Menghapus data ${formState?.nama}`}
        confirmText="Hapus"
        cancelText="Batal"
        idModal="alert"
        idData={formState?.id}
        onConfirm={(id, reason) => {
          handleDelete(id, reason);
        }}
        onCancel={() => {
          // closeModalDelete();
        }}
      />
    </div>
  );
};

const mapStateToProps = (state) => ({
  dataCities: state?.regions?.cities?.datas,
  cities: state?.regions?.cities?.datas?.data || [],
  isLoading: state?.regions?.cities?.loading,
  provinces: state?.regions?.provinces?.datas?.data || [],
  isLoadingProvince: state?.regions?.provinces?.loading,
});

export default connect(mapStateToProps, {
  fetchCities,
  addCity,
  updateCity,
  deleteCity,
  fetchProvinces,
})(CityPage);
